<template>
  <CommonLoginV2 platform="h5" />
</template>

<script>
import CommonLoginV2 from '@/views/common/loginV2.optimized.vue';

export default {
  name: 'H5LoginV2',
  components: {
    CommonLoginV2
  }
};
</script>